import { FormGroup } from '@angular/forms';
import { ExternalPointPost, Interval } from '../model/external-point.model';

type BaseData = {
  timezone: string;
  userLocale?: string;
  serviceDeliveryPointId: string;
};

function ensureDisplayLabels(input: any, userLocale: string = 'en_US'): Record<string, string> {
  if (typeof input === 'string') {
    const labels: Record<string, string> = { [userLocale]: input };
    if (userLocale !== 'en_US') labels['en_US'] = input;
    return labels;
  }

  if (input && typeof input === 'object') {
    const labels = { ...input };
    if (!labels['en_US']) {
      const firstKey = Object.keys(labels)[0];
      if (firstKey) labels['en_US'] = labels[firstKey];
    }

    return labels;
  }

  return { en_US: '' };
}

export function buildExternalPointPayloadFromForm(
  pointForm: FormGroup,
  base: BaseData,
  reportingIntervals: Interval[],
): ExternalPointPost {
  const reportingIntervalId = pointForm.get('reportingInterval')?.value;
  const reportingIntervalMs = findReportingIntervalMs(reportingIntervalId, reportingIntervals);
  const { timezone, userLocale = 'en_US', serviceDeliveryPointId } = base;
  const payload = {
    display_labels: ensureDisplayLabels(pointForm.get('displayLabels')?.value, userLocale),
    service_delivery_point_id: serviceDeliveryPointId,
    timezone,
    alternate_ids: { SOURCE_ID: pointForm.get('sourceId')?.value ?? null },
    space_type: 'ExternalPoint',
    status: 'ACTIVE',
    channel_id: pointForm.get('channelId')?.value != null ? Number(pointForm.get('channelId')?.value) : null,
    expression_factor:
      pointForm.get('expressionFactor')?.value != null ? Number(pointForm.get('expressionFactor')?.value) : 1,
    reporting_interval_ms: reportingIntervalMs,
    dataprovider_id: pointForm.get('dataproviderId')?.value ?? null,
    vee_bypass: pointForm.get('veeBypass')?.getRawValue(),
  };

  return payload;
}

export function findReportingIntervalMs(reportingIntervalId, reportingIntervals: Interval[]): number | null {
  const reportingIntervalMs = reportingIntervals.find((ri) => ri.id === reportingIntervalId).durationInMilliseconds;
  if (!reportingIntervalMs) {
    console.warn('Reporting interval ms not found for id:', reportingIntervalId);
    return null;
  }
  return Number(reportingIntervalMs);
}
